import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { map, take, shareReplay, find } from 'rxjs/operators';
import { AsyncCollectionElement } from '../../app-commons/operators/async-collection-element';

@Injectable({
  providedIn: 'root'
})
export class RaceResolver implements Resolve<AsyncCollectionElement> {

  constructor(
    private router: Router
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AsyncCollectionElement> {
    return from<Observable<AsyncCollectionElement>>(route.parent.data.races).pipe(
      find(race => race.model.id === +route.params.raceId),
      map(race => {
        if (race) {
          return race;
        } else {
          this.router.navigate(['/seasons', route.parent.params.seasonYear]);
          return null;
        }
      }),
      take(1),
      shareReplay(1)
    );
  }
}
